import { mapGetters } from 'vuex'
import $ from 'jquery'
global.jQuery = $
window.jQuery = $

export default {
  name: 'app-header',
  props: {
    hideShadow: { type: Boolean, default: false }
  },
  created () {
    this.initialization()
    this.stepupGet()
    this.getUnreadEsMyCard()
    if (localStorage.is_shop_master == 1 || localStorage.is_clerk == 1) {
      this.stepupCallGet()
      this.evaluateCallGet()
    }
    this.getUnreadCompanyNotice()
    if (localStorage.is_shop_master == 1) {
      this.getStockShopmasterNotice()
    }
  },
  data () {
    return {
      infoOpen: true,
      menuOpen: true,
      isStepUpCallExist: false,
      userTypesQuestion: false,
      isUnReadEsMyCardExist: false,
      isUnreadCompanyNoticeExist: false,
      stockShopmasterNoticeExist: false,
      isEvaluateCallExist: false,
      isClosedModal: false
    }
  },
  computed: {
    ...mapGetters({
      existProposeApprovedNotice: 'existProposeApprovedNotice',
      existProposeAdoptedNotice: 'existProposeAdoptedNotice',
      getNoanswermoralCount: 'noanswermoralCount',
      getUnapprovedProposeCount: 'unApprovedProposeCount',
      getRejectedCount: 'rejectedCount',
      existRequestHolidayNotice: 'existRequestHolidayNotice',
      getShiftNoticeCount: 'shiftNoticeCount',
      getShiftNotices: 'shiftNotices',
      existWillMustNotice: 'existWillMustNotice',
      getTargetmoralCount: 'targetmoralCount',
      targetServiceQuestionCount: 'targetServiceQuestionCount',
      ownServiceQuestion: 'ownServiceQuestion',
      noanswerServiceQuestionCount: 'noanswerServiceQuestionCount',
      isExistSafetyConfirmation: 'isExistSafetyConfirmation',
      isTrainingSafetyConfirmation: 'isTrainingSafetyConfirmation',
      isSentSafetyConfirmation: 'isSentSafetyConfirmation',
      isConfirmedSafetyConfirmation: 'isConfirmedSafetyConfirmation'
    }),
    isSystemManagement () {
      return window.localStorage.getItem('user_authority') === '1'
    },
    isShopMaster () {
      return window.localStorage.getItem('is_shop_master') === '1'
    },
    isOfficer () {
      return window.localStorage.getItem('is_officer') === '1'
    },
    isHarassment () {
      return window.localStorage.getItem('is_harassment') === '1'
    },
    getTargetmoralEnddate () {
      if (this.$store.getters.targetmoralEnddate) {
        return this.$store.getters.targetmoralEnddate.substr(5, 2) + '/' + this.$store.getters.targetmoralEnddate.substr(8, 2)
      } else {
        return ''
      }
    },
    getMessageCount () {
      if (this.isOfficer) {
        return this.$store.getters.messageofficerCount
      } else if (this.isShopMaster) {
        return this.$store.getters.messagemanagerCount
      } else if (this.isHarassment) {
        return this.$store.getters.messageharassmentCount
      } else {
        return 0
      }
    },
    infoCount () {
      var count = 0
      if (this.getTargetmoralCount > 0) {
        count += 1
      }
      if (this.isShopMaster && this.getNoanswermoralCount > 0) {
        count += 1
      }
      if (this.isSystemManagement && this.getUnapprovedProposeCount > 0) {
        count += 1
      }
      if (this.getMessageCount) {
        count += 1
      }
      if (this.getRejectedCount) {
        count += 1
      }
      if (this.existRequestHolidayNotice > 0) {
        count += 1
      }
      if (this.getShiftNoticeCount > 0) {
        count += this.getShiftNoticeCount
      }
      if (this.existWillMustNotice > 0) {
        count += 1
      }
      if (this.existProposeApprovedNotice > 0) {
        count += 1
      }
      if (this.existProposeAdoptedNotice > 0) {
        count += 1
      }
      if (this.isStepUpCallExist) {
        count += 1
      }
      if (this.isUnReadEsMyCardExist) {
        count += 1
      }
      if (this.isUnreadCompanyNoticeExist) {
        count += 1
      }
      if (this.stockShopmasterNoticeExist) {
        count += 1
      }
      if (this.isEvaluateCallExist) {
        count += 1
      }
      if (this.targetServiceQuestionCount > 0 || this.ownServiceQuestion) {
        count += 1
      }
      if (this.isShopMaster && this.noanswerServiceQuestionCount > 0) {
        count += 1
      }
      return count
    },
    profileImagePath () {
      return window.localStorage.getItem('profile_image_path') ? window.localStorage.getItem('profile_image_path') : ''
    },
    getUserFullName () {
      return window.localStorage.getItem('user_name')
    },
    authToken () {
      return window.localStorage.getItem('access_token')
    },
    timeStamp () {
      var d = new Date()
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate()
      var hour = (d.getHours() < 10) ? '0' + d.getHours() : d.getHours()
      var min = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year + '' + month + '' + day + '' + hour + '' + min + '' + sec
    },
    isStaging () {
      return process.env.NODE_ENV == 'staging' ? true:false
    },
    isShowSafetyConfirmation () {
      return ((
          this.isExistSafetyConfirmation && 
          !this.isTrainingSafetyConfirmation && 
          !this.isSentSafetyConfirmation
        ) || (
          !this.isClosedModal &&
          this.isExistSafetyConfirmation && 
          this.isTrainingSafetyConfirmation && 
          !this.isConfirmedSafetyConfirmation
        )) && 
        this.$route.path !== '/safety_confirmation'
    }
  },
  methods: {
    initialization: function () {
      var data = {
        'user_id': window.localStorage.getItem('user_id')
      }
      this.$store.dispatch('EXIST_SAFETY_CONFIRMATION')
      this.$store.dispatch('GET_TARGETMORAL_COUNT', { data: data })
      this.$store.dispatch('EXIST_REQUEST_HOLIDAY_NOTICE', { data: data })
      if (this.isShopMaster) {
        this.$store.dispatch('GET_NOANSWERMORAL_COUNT', { data: data })
        this.$store.dispatch('GET_MESSAGEMANAGER_COUNT', { data: data })
      }
      if (this.isOfficer) {
        this.$store.dispatch('GET_MESSAGEOFFICER_COUNT', { data: data })
      }
      if (this.isHarassment) {
        this.$store.dispatch('GET_MESSAGEHARASSMENT_COUNT', { data: data })
      }
      if (this.isSystemManagement) {
        this.$store.dispatch('GET_UNAPPROVED_PROPOSE_COUNT', { data: data })
      }
      this.$store.dispatch('GET_REJECTED_COUNT', { data: data })
      this.$store.dispatch('GET_SHIFT_NOTICE_COUNT', { data: data })
      this.$store.dispatch('EXIST_WILL_MUST_NOTICE', { data: data })
      this.$store.dispatch('EXIST_PROPOSE_NOTICE', { data: data })
      this.$store.dispatch('GET_NOANSWER_SERVICE_QUESTION_COUNT', { data: data })
      this.$store.dispatch('GET_TARGET_SERVICE_QUESTION_COUNT', { data: data })
    },
    async stepupGet () {
      let data = {
        user_id: localStorage.user_id
      }
      let res = await this.$store.dispatch('GET_STEPUP_EXIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      if (!res.exist) {
        this.userTypesQuestion = res.user_types_question
      }
    },
    async stepupCallGet () {
      let data = {
        shop_id: localStorage.shop_id
      }
      let res = await this.$store.dispatch('GET_STEPUP_CALL_EXIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.isStepUpCallExist = res.call_exist
    },
    async evaluateCallGet () {
      let data = {
        user_id: localStorage.user_id
      }
      let res = await this.$store.dispatch('GET_EVALUATE_ANSWER_CALL_EXIST', { data: data })
      .catch(err => {
        console.log(err)
        return
      })
      this.isEvaluateCallExist = res.call_exist
    },
    async getUnreadEsMyCard () {
      let res = await this.$store.dispatch('GET_UNREAD_ESMYCARD_EXIST')
      .catch(err => {
        console.log(err)
        return
      })

      this.isUnReadEsMyCardExist = res.exist
    },
    async getUnreadCompanyNotice () {
      let res = await this.$store.dispatch('GET_UNREAD_COMPANY_NOTICE_EXIST')
      .catch(err => {
        console.log(err)
        return
      })

      this.isUnreadCompanyNoticeExist = res.exist
    },
    async getStockShopmasterNotice () {
      let res = await this.$store.dispatch('GET_STOCK_SHOPMASTER_NOTICE_EXIST')
      .catch(err => {
        console.log(err)
        return
      })
      this.stockShopmasterNoticeExist = res.exist
    },
    goTop: function () {
      this.$router.push({path: '/'})
      this.closeMenu()
      this.closeInfo()
    },
    goReferral: function () {
      this.$router.push({path: '/referral'})
      this.closeMenu()
      this.closeInfo()
    },
    goMoral: function () {
      if (this.getTargetmoralCount > 0) {
        this.$router.push({path: '/moral_start'})
      } else {
        this.$router.push({path: '/message_sent'})
      }
      this.closeMenu()
    },
    goMoralStart: function () {
      this.$router.push({path: '/moral_start'})
      this.closeInfo()
    },
    goMoralNoAnswerList: function () {
      this.$router.push({path: '/moral_noanswer_list'})
      this.closeInfo()
    },
    goESMyCardMyList: function () {
      const userId = window.localStorage.getItem('user_id')
      this.$router.push({path: `/es_mycard_list/${userId}`})
      this.closeInfo()
    },
    goFrontUrl: function (path) {
      this.closeMenu()
      var url = process.env.FRONT_URL + '/static/html/redirect.html'
      var redirect = path
      // url
      var query = []
      query.push('access_token=' + encodeURIComponent(window.localStorage.getItem('access_token')))
      query.push('is_shop_master=' + encodeURIComponent(window.localStorage.getItem('is_shop_master')))
      query.push('keep_limit=' + encodeURIComponent(window.localStorage.getItem('keep_limit')))
      query.push('shop_id=' + encodeURIComponent(window.localStorage.getItem('shop_id')))
      query.push('user_authority=' + encodeURIComponent(window.localStorage.getItem('user_authority')))
      query.push('user_id=' + encodeURIComponent(window.localStorage.getItem('user_id')))
      query.push('redirect=' + encodeURIComponent(redirect))
      url += '?' + query.join('&')
      window.open(url, '_blank')
    },
    goShopmasterNotice () {
      this.closeInfo()
      let url = `${process.env.ZAIKO_URL}/manager-confirm`
      console.log(url)
      window.open(url, '_blank')
    },
    goMessageList: function () {
      this.$router.push({path: '/message_list'})
      this.closeInfo()
    },
    goRequestHolidayNew: function () {
      this.$router.push({path: '/request_holiday/new'})
      this.closeInfo()
    },
    goProposeAllshopList: function () {
      this.$router.push({path: '/propose_allshop_list'})
      this.closeMenu()
    },
    goProposeAdoptList: function () {
      this.$router.push({path: '/propose_adopt_list'})
      this.closeMenu()
    },
    goMessageSendManager: function () {
      this.$router.push({path: '/message_send_manager'})
      this.closeMenu()
    },
    goMessageSendOfficer: function () {
      this.$router.push({path: '/message_send_officer'})
      this.closeMenu()
    },
    goMessageSendHarassment: function () {
      this.$router.push({path: '/message_send_harassment'})
      this.closeMenu()
    },
    goCompanyNoticeList: function () {
      this.$router.push({path: '/company_notice_list'})
      this.closeInfo()
      this.closeMenu()
    },
    goChangePassword: function () {
      this.$router.push({path: '/menu_reset_password'})
      this.closeMenu()
    },
    goProfile: function () {
      window.sessionStorage.setItem('profile_detail_referrer', this.$router.history.current.path)
      this.$router.push({path: '/profile/' + window.localStorage.getItem('user_id')})
    },
    goProposeRejectedList: function () {
      this.$router.push({path: '/propose_rejected_list'})
      this.closeInfo()
    },
    goMagagineList: function () {
      this.$router.push({path: '/magazine_list'})
      this.closeMenu()
    },
    goShiftList: function () {
      var dt = new Date()
      var ym = dt.getFullYear() + '-' + ('00' + (dt.getMonth() + 1)).slice(-2)
      this.$router.push({path: '/shift_list/' + ym})
      this.closeMenu()
    },
    goEsMyCard: function () {
      this.$router.push({path: '/es_mycard_list'})
      this.closeMenu()
    },
    goShiftDetail: function (shiftDate) {
      this.$router.push({path: '/shift_detail/' + shiftDate})
      this.closeInfo()
    },
    goTreatmentSalaryList: function () {
      this.$router.push({ path: '/treatment_salary_list'})
    },
    goServiceQuestionAnswer: function () {
      if (this.ownServiceQuestion) {
        this.$router.push({ path: '/service_answers/' + this.ownServiceQuestion})
      } else {
        this.$router.push({ path: '/service_answers'})
      }
    },
    goServiceAnswerCallList: function () {
      this.$router.push({ path: '/service_answer_calls'})
    },
    getShiftDateString: function (shiftDate) {
      if (!shiftDate) return ''
      var dt = new Date(shiftDate)
      var m = ('00' + (dt.getMonth() + 1)).slice(-2)
      var d = ('00' + dt.getDate()).slice(-2)
      var result = m + '月' + d + '日'
      return result
    },
    logout: function () {
      this.$store.dispatch('LOGOUT')
    },
    onClickOmoiModalShow: function () {
      var button = document.getElementById('omoiModalButton')
      button.click() // モーダル表示 イベント発火
      $('.modal-backdrop').remove()
      this.closeMenu()
    },
    infoChange: function () {
      this.menuOpen = true
      if (this.infoOpen) {
        this.infoOpen = false
      } else {
        this.infoOpen = true
      }
    },
    menuChange: function () {
      this.infoOpen = true
      if (this.menuOpen) {
        this.menuOpen = false
      } else {
        this.menuOpen = true
      }
    },
    openInfo: function () {
      if (this.infoOpen) {
        return '-hidden'
      } else {
        return ''
      }
    },
    openMenu: function () {
      if (this.menuOpen) {
        return '-hidden'
      } else {
        return ''
      }
    },
    closeMenu: function () {
      this.menuOpen = true
    },
    closeInfo: function () {
      this.infoOpen = true
    },
    headerFix: function () {
      if (this.$route.name === 'moralSent') {
        return 'gheader-fix'
      } else {
        return ''
      }
    },
    noShadow: function () {
      if (this.$route.name === 'proposePersonalList' ||
          this.$route.name === 'proposeMyshopList' ||
          this.$route.name === 'proposeAllshopList' ||
          this.$route.name === 'proposeSearchList' ||
          this.$route.name === 'proposeRejectedList' ||
          this.hideShadow) {
        return 'no-shadow'
      } else {
        return ''
      }
    },
    goWillMustEdit: function () {
      this.$router.push({path: '/will_must/edit'})
    },
    goWillMust: function () {
      this.$router.push({path: '/will_must_list'})
    },
    checkVideoTerms: function () {
      const button = document.getElementById('videoTermsModalButton')
      button.click()
      $('.modal-backdrop').remove()
      this.closeMenu()
    },
    goVideoCategories: function () {
      this.$router.push({ path: '/video_categories' })
    },
    goStepUpCallList: function() {
      this.$router.push({ path: '/stepup/call_list' })
      this.closeInfo()
    },
    goEvaluateCallList: function () {
      this.$router.push({ path: '/evaluate_answer/call_list' })
      this.closeInfo()
    },
    goStepUpQuestionCheck: function(division) {
      const query = {
        division: division
      }
      this.$router.push({ path: '/stepup/question_check', query: query })
      this.closeMenu()
    },
    goStepUpAnswerEdit: function() {
      this.closeInfo()
      window.scroll(0,0)
    },
    goSafetyConfirmation: function () {
      this.$router.push({ path: '/safety_confirmation' })
      window.scroll(0,0)
    },
    closeSafetyConfirmation: function () {
      this.$store.dispatch('GET_SAFETY_CONFIRMATION_ANSWER')
      this.isClosedModal = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/app-header.js